import * as React from "react";

;
export const X = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="#100722" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 10.94L4.53 3.47 3.47 4.53 10.94 12l-7.47 7.47 1.06 1.06L12 13.06l7.47 7.47 1.06-1.06L13.06 12l7.47-7.47-1.06-1.06L12 10.94z" /></svg>;